module.exports = __webpack_public_path__ + "img/lives.6e989c45.svg";